module.exports = __webpack_public_path__ + "src/img/artist/name02.svg?74e868f26b67f6cf35ee4c6400b6ec36";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/name02.svg
// module id = 138
// module chunks = 0